import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import BaseData from "./BaseData";

var InsurancClaimRequest =
/*#__PURE__*/
function (_BaseData) {
  _inherits(InsurancClaimRequest, _BaseData);

  function InsurancClaimRequest() {
    _classCallCheck(this, InsurancClaimRequest);

    return _possibleConstructorReturn(this, _getPrototypeOf(InsurancClaimRequest).call(this, "InsuranceClaimRequest"));
  }

  _createClass(InsurancClaimRequest, [{
    key: "GetByClaimId",
    value: function () {
      var _GetByClaimId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(id) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetByClaimId/").concat(id)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetByClaimId(_x) {
        return _GetByClaimId.apply(this, arguments);
      }

      return GetByClaimId;
    }()
  }, {
    key: "RemovePropertyException",
    value: function () {
      var _RemovePropertyException = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(ProjectId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/RemovePropertyException/").concat(ProjectId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function RemovePropertyException(_x2) {
        return _RemovePropertyException.apply(this, arguments);
      }

      return RemovePropertyException;
    }()
  }, {
    key: "CopyW9s",
    value: function () {
      var _CopyW9s = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(requestId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.post("/api/".concat(this._controller, "/CopyW9s/").concat(requestId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function CopyW9s(_x3) {
        return _CopyW9s.apply(this, arguments);
      }

      return CopyW9s;
    }()
  }]);

  return InsurancClaimRequest;
}(BaseData);

export default new InsurancClaimRequest();